import React from 'react';
import type { BrandIconProps } from '.';
import { BrandIconDefaultSize } from '.';

export const Venmo = React.forwardRef(
  ({ size = BrandIconDefaultSize, ...props }: BrandIconProps, svgRef: React.Ref<SVGSVGElement>) => {
    return (
      <svg
        viewBox="0 0 82 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        ref={svgRef}
        {...props}
      >
        <path
          d="M13.8434 0.794434C14.3918 1.69336 14.6345 2.62824 14.6345 3.79684C14.6345 7.53637 11.4343 12.3996 8.84542 15.8155H2.91251L0.54834 1.61246L5.73514 1.11805L6.99363 11.231C8.17123 9.31625 9.6185 6.31383 9.6185 4.26429C9.6185 3.14063 9.42972 2.37654 9.12409 1.74729L13.8434 0.794434ZM20.5674 7.05095C21.5203 7.05095 23.9294 6.61048 23.9294 5.24411C23.9294 4.5879 23.4619 4.26429 22.9226 4.26429C21.9697 4.26429 20.7112 5.41491 20.5764 7.05095H20.5674ZM20.4595 9.74773C20.4595 11.4107 21.3854 12.067 22.617 12.067C23.9653 12.067 25.2418 11.7433 26.9048 10.8894L26.2756 15.1503C25.098 15.7256 23.2732 16.1031 21.4933 16.1031C16.9987 16.1031 15.3716 13.3704 15.3716 9.95448C15.3806 5.54076 18.0055 0.83938 23.408 0.83938C26.3745 0.83938 28.0465 2.50239 28.0465 4.83061C28.0465 8.57913 23.2372 9.72076 20.4595 9.74773ZM43.0226 4.12945C43.0226 4.67779 42.9417 5.47783 42.8608 5.99022L41.3056 15.8245H36.2537L37.674 6.80824L37.7818 5.80145C37.7818 5.14523 37.3683 4.98343 36.8829 4.98343C36.2267 4.98343 35.5705 5.28007 35.139 5.5048L33.5299 15.8424H28.451L30.7612 1.10007H35.1659L35.2199 2.27766C36.2537 1.59448 37.62 0.857358 39.5617 0.857358C42.1326 0.857358 43.0315 2.16979 43.0315 4.13844L43.0226 4.12945ZM58.0166 2.44846C59.4549 1.41469 60.8303 0.83938 62.709 0.83938C65.3069 0.83938 66.2148 2.15181 66.2148 4.12046C66.2148 4.6688 66.1339 5.46885 66.053 5.98123L64.4979 15.8155H59.4279L60.8662 6.61048L60.9471 5.87336C60.9471 5.13624 60.5336 4.97444 60.0482 4.97444C59.419 4.97444 58.7897 5.24411 58.3313 5.49581L56.7132 15.8335H51.6612L53.0995 6.62846L53.1894 5.89134C53.1894 5.15422 52.7759 4.99241 52.2905 4.99241C51.6343 4.99241 50.978 5.28906 50.5466 5.51379L48.9375 15.8514H43.8586L46.1598 1.11805H50.5016L50.6365 2.34957C51.6433 1.61246 53.0096 0.875337 54.8434 0.875337C56.4255 0.875337 57.4683 1.55852 57.9807 2.48441L58.0076 2.46643L58.0166 2.44846ZM76.2648 6.73633C76.2648 5.53177 75.9682 4.71375 75.0603 4.71375C73.0646 4.71375 72.6601 8.23754 72.6601 10.0444C72.6601 11.4107 73.0467 12.2557 73.9456 12.2557C75.8333 12.2557 76.2648 8.53418 76.2648 6.73633V6.73633ZM67.5273 9.82863C67.5273 5.19018 69.9813 0.848369 75.6356 0.848369C79.8965 0.848369 81.4516 3.36536 81.4516 6.83521C81.4516 11.4287 79.0245 16.184 73.2354 16.184C68.9476 16.184 67.5273 13.3704 67.5273 9.84661V9.82863Z"
          fill="white"
        />
      </svg>
    );
  }
);

export const VenmoIcon = React.forwardRef(
  ({ size = BrandIconDefaultSize, ...props }: BrandIconProps, svgRef: React.Ref<SVGSVGElement>) => {
    return (
      <svg
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        ref={svgRef}
        {...props}
      >
        <path
          d="M17.8398 8.14704L9.45166 8.93724L13.4026 32.3392H23.0673C33.036 19.6961 33.2183 11.7941 31.1516 7.66077L23.4928 9.36273C25.7783 14.5172 22.0137 22.0869 19.8458 25.1059L17.8398 8.14704Z"
          fill="#0098D2"
        />
      </svg>
    );
  }
);
